<template>
	<div class="learner_program_data">

		<div class="row">
      <div class="col-12">
        <template>
          <b-card class="text-center prog-lmi ace_sec" aria-label="Application Status for">

						<template #header>
              <div class="hd_ic" v-if="userSISProgramMapping.programLogo">
								<img :src="userSISProgramMapping.programLogo">
							</div>
        			<div class="hd_txt">
								Application Status for <span v-if="userSISProgramMapping.programTitle">{{userSISProgramMapping.programTitle}}</span>
							</div>
      			</template>

						<div class="crd_content">

							<b-card-text>
	              <div class="row sec_row">
	                <div class="col-12 app_plan_status">
                    <template v-if="showLoader">
                      Loading..
                    </template>
                    <template v-if="!showLoader">
                      <template v-if="Object.keys(userSISProgramMapping).length > 0">
                        <template v-if="userSISProgramMapping.status === 'IN_PROGRESS'">
													<div class="status_info">
                          	<span class="txt"> Application In Progress </span>
													</div>
													<div class="btn_container">
	                          <b-btn @click.stop.prevent="resendApplicationLink">
	                            <span class="btn_txt"> Re-send application link</span>
	                          </b-btn>
													</div>
                        </template>
                        <template v-if="userSISProgramMapping.status === 'SUBMITTED' || userSISProgramMapping.status === 'PENDING_DECISION'">
													<div class="ic_container">
														<span class="ic ic22-hour-glass"></span>
													</div>
													<div class="status_info">
                          	<span class="txt">Decision Pending</span>
													</div>
                        </template>
                        <template v-if="userSISProgramMapping.status === 'ACCEPTED' && userSISProgramMapping.feeStatus === 'UNPAID'">
                          <div class="status_info">
														<span class="btn_txt">Application Approved</span>
													</div>
													<div class="btn_container">
	                          <b-btn :href="paymentUrl" target="_blank">
	                            <span class="btn_txt">Make Payment</span>
	                          </b-btn>
													</div>
                        </template>
                        <template v-if="userSISProgramMapping.status === 'ACCEPTED' && (userSISProgramMapping.feeStatus === 'PAID' || userSISProgramMapping.feeStatus === 'WAIVED')">
													<div class="ic_container">
														<span class="ic ic22-hour-glass"></span>
													</div>
													<div class="status_info">
														<span class="txt">Enrollment Pending</span>
													</div>
                        </template>
                      </template>
                    </template>
                  </div>
	              </div>
	            </b-card-text>
						</div>

						<div class="lnk_container">

						</div>

          </b-card>
        </template>
      </div>
    </div>

	</div>
</template>

<script>
	import { mapActions } from 'vuex'
	import VClamp from 'vue-clamp'


	export default {
		name: 'learner-application-pending',
		components: {
			VClamp
		},
    props: [],
    mounted () {
      this.loadApplicationPending()
    },
    data: () => {
      return {
        showLoader: false,
        userSISProgramMappings: [],
        userSISProgramMapping: {},
        paymentUrl: ''
      }
    },
		methods: {
      ...mapActions([
        'loadAllUserSISProgramMappings',
        'loadUserSISProgramMapping',
        'loadCreateApplication',
        'loadResendApplicationLink',
        'loadPaymentLink'
      ]),
      async loadApplicationPending() {
        this.showLoader = true
        this.userSISProgramMappings = await this.loadAllUserSISProgramMappings()
        if (this.userSISProgramMappings.length > 0) {
          this.userSISProgramMapping = this.userSISProgramMappings[0]
          console.log("Title: ", this.userSISProgramMapping.programTitle)
          if (this.userSISProgramMapping.status === 'ACCEPTED' && this.userSISProgramMapping.feeStatus === 'UNPAID') {
            this.paymentUrl = await this.loadPaymentLink({sisProgramId:this.userSISProgramMapping.programId, sisDegreeId:this.userSISProgramMapping.degreeId})
          }
        }
        this.showLoader = false
      },
      async resendApplicationLink () {
        this.showLoader = true
        await this.loadResendApplicationLink({sisProgramId:this.userSISProgramMapping.programId, sisDegreeId:this.userSISProgramMapping.degreeId})
        this.showLoader = false
        this.$notify({
          group: 'notify',
          type: 'succes',
          title: '',
          text: 'Please check your email for application link'
        })
      },
		}
	}
</script>

<style scoped>
  .prog-lmi .card-header {
    height: 65px;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerApplicationPending.vue